import React from 'react';
import { Link } from "react-router-dom";

import {urlFor} from '../../utils/sanity/urlFor';
import { useSelector } from 'react-redux';

import AboutBoldPhrase from './AboutBoldPhrase.jsx'
import SkillSection from './SkillSection'
import ContactSection from '../../components/ContactSection';



function Home({userData, skillsData}) {
  const navbarHeight = useSelector((state) => state.navbarHeight);
  const userInfo = [userData]
  
  return (
    <main className='max-w-screen min-h-screen px-6 xl:px-40 md:px-10'>
      { userInfo && userInfo.map((user, index) => (
        <React.Fragment key={index}>
          <section className='w-full flex justify-center text-center pt-32' style={{height: `calc(100vh - ${navbarHeight}px)`}}>
            <div className=' rounded-tr-3xl'>
              <h1 className='main-font text-base lg:text-lg md:text-lg text-center tracking-widest m-1 md:m-3'>
                {user.intro}
              </h1>
              <h1 className='heading-font  text-2xl md:text-6xl tracking-widest m-1 md:m-3'>
                VILLAMOR GO
              </h1>
              <h2 className='main-font text-base tracking-widest'>
                Fullstack Web Developer
              </h2>
              <span className='main-font text-base tracking-widest mt-3 w-full md:w-2/5 flex absolute left-1/2 -translate-x-1/2 bottom-6 px-2'>
                <div className="flex-auto w-auto flex items-center py-3 pl-9">
                  <div className="flex-grow h-px bg-gray-400 mx-8 block"></div>
                </div>
                <p className='px-2 md:px-1 py-2 font-medium text-black'>
                  Scroll
                </p>
                <div className="flex-auto w-auto flex items-center py-3 pr-9">
                  <div className="flex-grow h-px bg-gray-400 mx-8 block"></div>
                </div>
              </span>
            </div>
          </section>
          <section className="flex flex-col md:flex-row w-full mb-10 xl:mb-40 mt-12 xl:mt-0" id="about">
            <div className="w-full md:w-1/2 margin">
              <img src={urlFor(user.userImage)} alt="backgroundImg" className="lg:img-max-height img-max-height w-auto m-auto"/>
            </div>
            <div className="w-full md:w-1/3 border-y border-gray-400 py-7 md:py-12 pt-5 xl:pt-14 mx-0 md:mx-16">
              <h2 className="heading-font text-2xl md:text-4xl font-bold">
                About Me
              </h2>
              <div className="main-font text-base leading-7 tracking-wider pt-0 md:pt-2 md:pb-6" id='about'>
                <AboutBoldPhrase about={user.about} />
              </div>
              <Link to="/portfolio" className="hover:text-white text-sm md:text-xs tracking-widest border border-black px-4 md:px-10 py-2 md:py-4 flex items-center m-auto btn5">
                GO TO PORTFOLIO
              </Link>
            </div>
          </section>
          
          {skillsData && <SkillSection skillsData={skillsData}/>}
          <ContactSection/>
          
        </React.Fragment>
      ))}
    </main>
  )
}

export default Home;